
import "bootstrap/dist/css/bootstrap.css";

import { defineComponent } from "vue";
import { useStore } from "vuex";

import { onMounted, computed, reactive, toRefs, h, watch } from "vue";

const items = [
    {
        date: "ChineseCHI LBW 2021, VIS 2022-23 (Short Paper), ChinaVIS 23, CHI 2023",
        html: "Program Committee",
    },
    {
        date: "CHI 2021-2022, VIS 2020-2022, EuroVis 2020-2022, PacificVis 2020/2022, ChinaVis 2020-2021, UIST 2021",
        html: "Conference Reviewer",
    },
    {
        date: "TVCG, TiiS",
        html: "Journal Reviewer",
    },
    {
        date: "ChinaVis Visual Analytics Challenge 2021",
        html: "Judge",
    },
    {
        date: "VIS 2020",
        html: "Student Volunteer (SV)",
    },
];

const uniServiceItems = [
    {
        date: "Conversation with SENG Alumni, by School of Engineering (SENG), HKUST, 2022",
        html: "Master of Ceremony",
    },
    {
        date: "Donor visit by Hutchison Telecommunications International Limited, hosted by School of Engineering, HKUST, 2021 <br /> Donor visit by Swire, hosted by HKUST, 2019 <br /> Donor visit by Sino Group, hosted by HKUST, 2019",
        html: "Demonstration Presenter",
    },
    {
        date: "Committee on RPg Student Hubs, HKUST, 2021",
        html: "Committee Student Representative",
    },
    {
        date: "Summer Camp for Elite Students, by School of Engineering, HKUST, 2018-2019 <br /> New Student Orientation, by School of Engineering, HKUST, 2018-2019 <br /> HKUST Opening Day, 2018 <br /> ",
        html: "Event Student Representative/Helper",
    },
    {
        date: "HKUST Outstanding Students Banquet 2016-17 <br /> HKUST 25th Anniversary Celebration Banquet, 2016",
        html: "Nominated Student Guest",
    }
];

export default defineComponent({
    name: "App",
    components: {},
    setup() {
        const store = useStore();

        const state = reactive({
            svgStr: computed(() => store.state.svgStr),
        });

        return {
            ...toRefs(state),
            items,
            uniServiceItems,
        };
    },
    computed: {},
});
